import HAIR_CATEGORIES from './hair_categories';

const HAIR_PRODUCT_TYPES = {};
HAIR_PRODUCT_TYPES[HAIR_CATEGORIES.HAIR_CARE] = [
  'Fine Hair',
  'Color Fade',
  'Frizz',
  'Unruly Hair',
  'Coarse Texture',
  'Hair Loss',
  'Color Change',
  'Dandruff',
  'Grey/White Hair',
  'UV Protection',
  'Thick Hair',
  'Coily Hair',
  'Sensitive Scalp',
  'Natural Texture',
  'Dry Hair',
  'Oily Scalp',
  'Damaged Hair',
  'Long Hair',
  'Split Ends',
  'Curly Hair',
  'Hard to Style',
  'Limp Hair',
  'Hair Breakage',
  'Dry Ends',
  'Oily Hair',
  'Thin Hair',
  'Lack of Shine',
];
HAIR_PRODUCT_TYPES[HAIR_CATEGORIES.HAIR_STYLING] = [
  'Fine Hair',
  'Color Fade',
  'Frizz',
  'Unruly Hair',
  'Texture',
  'Color Protection',
  'Dry Hair',
  'Damaged Hair',
  'Short Hair',
  'Curly Hair',
  'Hard to Style',
  'Limp Hair',
  'Oily Hair',
  'Thin Hair',
  'Lack of Shine',
  'Wavy Hair',
  'Wet Look',
  'Lasting Hold',
  'Long Hair',
  'Natural Look',
  'Thick Hair',
  'Straightening',
  'UV Protection',
];
HAIR_PRODUCT_TYPES[HAIR_CATEGORIES.HAIR_COLOR] = [
  'Color Fade',
  'Color Protection',
  'Color Change',
  'Hair Texture',
  'Ease of Application',
  'Hair Damage',
  'Color Vibrancy',
  'Hair Shine',
  'Color Staying True',
  'Natural Looking Color',
  'Grey Coverage',
  'Odor',
  'Safety',
  'Messiness',
  'Highlights',
];

export default HAIR_PRODUCT_TYPES;
